import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {HeaderFieldFragment, WidgetEntityType} from 'nutshell-graphql-types';
import type {
    GetPeepWidgets as GetPeepWidgetsQuery,
    GetPeepWidgetsVariables,
    GetPeepWidgets_entityTypeWidgets as EntityTypeWidgets,
} from 'nutshell-graphql-types';

import GET_PEEP_WIDGETS from '../queries/get-peep-widgets.graphql';

export function useGetPeepWidgets(entityType: WidgetEntityType): {
    widgets: EntityTypeWidgets | null | undefined;
    headerFields: HeaderFieldFragment[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<GetPeepWidgetsQuery, GetPeepWidgetsVariables>(
        GET_PEEP_WIDGETS,
        {
            variables: {entityType: entityType},
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        widgets: data?.entityTypeWidgets,
        headerFields: data?.entityTypeWidgets?.headerFields ?? [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
